import React from 'react';

class PrivacyPolicySection extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            sections: [
                {
                    id: 1,
                    title: "Introduction",
                    content: "Trucking Empire leverages blockchain technology to revolutionize the logistics industry. Our platform facilitates fractional ownership of semi-trucks through NFTs and offers an immersive trucking management game. This Privacy Policy clarifies our stance on data collection, emphasizing our commitment to user privacy and the inherent security features of blockchain technology."
                },
                {
                    id: 2,
                    title: "Blockchain and Privacy",
                    content: "Blockchain technology provides a transparent, secure, and decentralized method of recording transactions. Personal data traditionally required by centralized platforms is not directly collected or stored on the blockchain, enhancing user privacy."
                },
                {
                    id: 3,
                    title: "Indirect Data Collection",
                    content: "While direct personal data collection is minimal, interactions with our platform via blockchain transactions may indirectly provide public data such as wallet addresses. This information, inherently public due to the nature of blockchain, is used strictly for transaction validation and NFT ownership verification."
                },
                {
                    id: 4,
                    title: "Use of Data",
                    content: "Any data collected indirectly through blockchain interactions is utilized to ensure the smooth operation of Trucking Empire's NFT marketplace and gaming platform, to secure transactions, and to enhance user experience."
                },
                {
                    id: 5,
                    title: "Data Protection",
                    content: "We respect the privacy of our users and are committed to protecting it. We encourage users to understand the public nature of blockchain and manage their digital wallets and interactions accordingly."
                },
                {
                    id: 6,
                    title: "Changes to This Privacy Policy",
                    content: "Our Privacy Policy may evolve with the growth of Trucking Empire and advancements in blockchain technology. We recommend users review our policy periodically. Updates will be communicated through our platform."
                },
                {
                    id: 7,
                    title: "Contact Us",
                    content: "For questions or concerns about our privacy practices or your experience with Trucking Empire, please reach out to us via our official contact channels."
                },
            ]
        };
    }

    render() {
        return (
            <><div id="privacy-policy" className='py-5'>
                <div className='container'>
                    <div className='row py-5'>
                        <div className='col-md-8 m-auto'>
                            <div className="section-title text-center py-5">
                                <h2 className="title text-capitalize">Privacy Policy</h2>
                            </div>
                            <p className='text-center pb-5 mt-3'>This Privacy Policy outlines our practices in handling information related to your interaction with Trucking Empire, with a specific focus on the limited nature of data collection and the use of blockchain technology.</p>
                        </div>
                    </div>
                </div>
                <div className='privacy-policy-area py-5'>
                    <div className='container'>
                        {this.state.sections.map(section => (
                            <div className="privacy-section mb-4" key={section.id}>
                                <h3 className="mb-3">{section.title}</h3>
                                <p>{section.content}</p>
                            </div>
                        ))}
                    </div>
                </div>
            </div><div id="terms-of-use" className='py-5'>
                    <div className='container'>
                        <div className='row py-5'>
                            <div className='col-md-12'>
                                <div className="section-title text-center py-5">
                                    <h2 className="title text-capitalize">Terms of Use</h2>
                                </div>
                                <p className='text-center pb-5 mt-3'>Welcome to Trucking Empire. The following terms and conditions govern all use of the Trucking Empire website and all content, services, and products available at or through the website, including, but not limited to, Trucking Empire NFTs (Non-Fungible Tokens), staking services, and our gaming platform (taken together, the Services). The Services are offered subject to your acceptance without modification of all of the terms and conditions contained herein and all other operating rules, policies (including, without limitation, Trucking Empireâs Privacy Policy), and procedures that may be published from time to time by Trucking Empire (collectively, the âAgreementâ).</p>

                                <h3>1. Acceptance of Terms</h3>
                                <p>By accessing or using any part of the Services, you agree to become bound by the terms and conditions of this agreement. If you do not agree to all the terms and conditions of this agreement, then you may not access the website or use any services.</p>

                                <h3>2. NFT Ownership and Rights</h3>
                                <p>When you purchase or otherwise acquire an NFT from Trucking Empire, you receive a digital certificate of ownership of a limited license to use the NFT. Ownership of the NFT is governed entirely by the smart contract and blockchain network of [specify blockchain, e.g., Ethereum].</p>

                                <h3>3. Staking</h3>
                                <p>Users may have the option to stake certain NFTs within Trucking Empireâs platform to earn rewards. Staking is subject to terms that will be provided at the time of staking. You understand the risks associated with staking, including but not limited to the potential loss of staked NFTs.</p>

                                <h3>4. Use of Services</h3>
                                <p>You are responsible for your actions when using Trucking Empireâs Services. Prohibited actions include, but are not limited to, engaging in illegal activities, infringing on intellectual property, and conducting transactions with stolen or unauthorized payment methods.</p>

                                <h3>5. Disclaimer of Warranties</h3>
                                <p>The Services are provided âas isâ. Trucking Empire and its suppliers and licensors hereby disclaim all warranties of any kind, express or implied, including, without limitation, the warranties of merchantability, fitness for a particular purpose and non-infringement. Neither Trucking Empire nor its suppliers and licensors make any warranty that the Services will be error free or that access thereto will be continuous or uninterrupted.</p>

                                <h3>6. Limitation of Liability</h3>
                                <p>In no event will Trucking Empire, or its suppliers or licensors, be liable with respect to any subject matter of this agreement under any contract, negligence, strict liability or other legal or equitable theory for: (i) any special, incidental or consequential damages; (ii) the cost of procurement for substitute products or services; (iii) for interruption of use or loss or corruption of data.</p>

                                <h3>7. General Representation and Warranty</h3>
                                <p>You represent and warrant that your use of the Services will be in strict accordance with the Trucking Empire Privacy Policy, with this Agreement, and with all applicable laws and regulations.</p>

                                <h3>8. Changes</h3>
                                <p>Trucking Empire reserves the right, at its sole discretion, to modify or replace any part of this Agreement. It is your responsibility to check this Agreement periodically for changes. Your continued use of or access to the Services following the posting of any changes to this Agreement constitutes acceptance of those changes.</p>

                                <h3>9. Contact Information</h3>
                                <p>For any questions regarding these Terms of Use, please contact us at [insert contact information].</p>
                            </div>
                        </div>
                    </div>
                </div></>
        );
    }
}

export default PrivacyPolicySection;
